import { useCurrentBox } from "@modules/box/useBox"
import { useServicesContext } from "@modules/core/services/services.context"
import { word } from "@modules/core/utils/i18n"
import { useLanguage } from "@modules/language/hooks/useLanguage"
import { useToast } from "@modules/ui/components/huToast"
import { verboseDateIntervalFormat } from "@modules/utils/dateUtils"
import dayjs from "dayjs"
import { useObservable } from "micro-observables"

export const useBoxProgrammationSessionDuplicate = () => {
  const { boxSlotService } = useServicesContext()
  const { result: currentBox } = useCurrentBox()
  const toast = useToast()
  const language = useLanguage()
  const weekCopied = useObservable(boxSlotService.copyWeek)

  const onCopyBoxProgrammationSessionWeek = (
    programId: string,
    programName: string,
    originStartDate: string,
    originEndDate: string,
  ) => {
    if (currentBox)
      boxSlotService.setWeekToCopy(
        currentBox.id,
        currentBox.name,
        programId,
        programName,
        originStartDate,
        originEndDate,
      )

    toast.show({ severity: "success", detail: word("program.weekCopyPaste.copy.success") })
  }

  const onPasteBoxProgrammationSessionWeek = async (
    destinationProgramId: string,
    destinationStartDate: string,
    overwrite?: boolean,
  ) => {
    if (weekCopied) {
      try {
        await boxSlotService.copyWeekToAnother(
          weekCopied.originProgramId,
          destinationProgramId,
          weekCopied.originStartDate,
          weekCopied.originEndDate,
          destinationStartDate,
          overwrite,
        )

        const formattedDates = verboseDateIntervalFormat(
          dayjs(weekCopied.originStartDate),
          dayjs(weekCopied.originEndDate),
          language,
        )

        toast.show({ severity: "success", detail: word("program.weekCopyPaste.paste.success", { formattedDates }) })

        boxSlotService.clearWeekToCopy()
      } catch (e: any) {
        toast.show({ severity: "error", summary: word("program.weekCopyPaste.paste.error"), detail: e.message })
      }
    }
  }

  return {
    onCopyBoxProgrammationSessionWeek,
    onPasteBoxProgrammationSessionWeek,
    weekCopied,
  }
}
